var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"date-time-format-on-table"}},[_vm._v(" "+_vm._s(_vm.formatDateComputed)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }